var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.rounds),function(round){return _c('JobRoundDisplay',{key:round.id,attrs:{"round":round,"week_index":_vm.selected_week_index,"day_index":_vm.day_index,"editable":false,"schedule_index":_vm.schedule_index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }